import { selectQualityCommentaryTableDisplay } from '../../../redux/features/selectors/commentarySelectors/selectQualityCommentary.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { CommentarySubSection } from '../components/CommentarySubsection.tsx';
import { CommentaryTable } from '../components/CommentaryTable.tsx';
import { COMMENTARY_TEXT } from '../consts.ts';
import { CRAFTSMAN_QUALITY_FOOTNOTE } from '../consts.ts';

const props = COMMENTARY_TEXT['dep-cost'].subItems.quality;

export const Quality = () => {
  const data = useAppSelector((state) => selectQualityCommentaryTableDisplay(state));

  return (
    <CommentarySubSection {...props}>
      <CommentaryTable {...data} footnote={CRAFTSMAN_QUALITY_FOOTNOTE} />
    </CommentarySubSection>
  );
};
